import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getInventoryItemsAJAX } from "../../actions/inventory_items";
import { readDueInventoryItemConfig } from "../../utilities/dueInventoryItem";
import { BaseField } from "../BaseField";
import { Configurable } from "./Configurable";

const DueInventoryItemEditor = ({ register, keyName, value }) => {
    const initial = readDueInventoryItemConfig(value);
    const [items, setItems] = useState<any[]>([]);
    const [item, setItem] = useState<any>(
        initial
            ? { id: initial.inventoryItemId, short_name: initial.shortName, name: initial.name }
            : null
    );
    const [lifetimeYears, setLifetimeYears] = useState<string>(
        initial ? String(initial.lifetimeYears) : ""
    );

    useEffect(() => {
        getInventoryItemsAJAX({ page_size: -1 }, ["repair", "service", "disposal"])
            .then((result) => {
                setItems(result.data?.inventory_items || []);
            })
            .catch((err) => console.error(err));
    }, []);

    const serialized =
        item && lifetimeYears !== ""
            ? JSON.stringify({
                  inventoryItemId: item.id,
                  shortName: item.short_name,
                  name: item.name || item.short_name,
                  lifetimeYears: parseInt(lifetimeYears, 10),
              })
            : "";

    const toOption = (i: any) => ({
        value: i.id,
        label: i.nr ? `${i.nr} – ${i.short_name}` : i.short_name,
        cell: i,
    });

    return (
        <div>
            <label>LV-Position</label>
            <Select
                isClearable
                placeholder="Keine (keine Prüfung)"
                options={items.map(toOption)}
                value={item ? toOption(item) : null}
                onChange={(option: any) => setItem(option ? option.cell : null)}
            />
            <label className="mt-2">Lebensdauer in Jahren</label>
            <input
                type="number"
                min={0}
                className="form-control"
                value={lifetimeYears}
                onChange={(ev) => setLifetimeYears(ev.currentTarget.value)}
            />
            <input type="hidden" name={keyName} ref={register} value={serialized} />
        </div>
    );
};

export class DueInventoryItem extends Configurable {
    public keyName = "dueInventoryItem";
    public title = "LV-Position bei Fälligkeit";
    public description =
        "Bei der Angebotserstellung wird diese Position hinzugefügt, wenn Datum + Lebensdauer bis 12 Monate nach dem Angebotsdatum erreicht ist";

    public EditComponent({
        register,
        field,
    }: {
        register: any;
        schema: any;
        designer: any;
        field: BaseField;
    }): any {
        return (
            <DueInventoryItemEditor
                register={register}
                keyName={this.keyName}
                value={field.rawOptions[this.keyName]}
            />
        );
    }

    public sleepValue(value): any {
        return readDueInventoryItemConfig(value);
    }

    public wakeValue(value) {
        return readDueInventoryItemConfig(value);
    }
}
